export interface NavLink {
  label: string;
  href: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: "Inicio",       href: "#inicio" },
  { label: "Serviços",     href: "#servicos" },
  { label: "Portfólio",    href: "#portfolio" },
  { label: "Avaliações",   href: "#avaliacoes" },
];

export const COLORS = {
  fundo:      "#F7EADB",
  texto:      "#1A1714",
  destaque:   "#8B6C52",
  linha:      "#E8E0D6",
};

export const FONTS = {
  titulo:     "'Cormorant Garamond', serif",
  corpo:      "'Jost', sans-serif",
};

export const DIMENSIONS = {
  alturaNv:   "72px",
  gapLinks:   "36px",
  gapMobile:  "32px",
};

export const TIMING = {
  transicao:  "0.35s cubic-bezier(0.4, 0, 0.2, 1)",
  scrollThreshold: 20,
};

export const BREAKPOINTS = {
  mobile:     "768px",
};

export const TEXTS = {
  ctaLabel:   "Fale Comigo",
  logoName:   "Cris Morais",
};